var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 0.666626C3.93842 0.666626 0.666626 3.93842 0.666626 7.99996C0.666626 12.0615 3.93842 15.3333 7.99996 15.3333C12.0615 15.3333 15.3333 12.0615 15.3333 7.99996C15.3333 3.93842 12.0615 0.666626 7.99996 0.666626ZM6.92816 10.8769L4.33329 8.28201L5.17945 7.43586L6.98457 9.18457L10.8205 5.40509L11.6666 6.25124L6.92816 10.8769Z",
    fill: "#0F8A15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckmark);
export default __webpack_public_path__ + "static/media/GreenCheckmark.65d328c2522ea4f4cb7649d0da464e0f.svg";
export { ForwardRef as ReactComponent };